// dayjs formats
export const US_DATE_FORMAT = 'MM-DD-YYYY';
export const DATE_FORMAT = US_DATE_FORMAT;
export const TIME_FORMAT = 'hh:mm A';
// react-datepicker format (exceptions)
export const DATE_PICKER_DATE_FORMAT = 'MM-dd-yyyy';
export const DATE_PICKER_TIME_FORMAT = 'hh:mm a';

export const SUPPORTED_WEB_VIDEO_FORMATS = ['mp4', 'webm', 'ogg'];
export const WEEKDAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

export const GridYValue = 10;
export const GridXValue = 1;
export const GridYUnit = 'px';
export const GridXUnit = '%';
export const SCHEDULING_HOURS_OPTIONS = [
  { value: 0, label: '0' },
  { value: 1, label: '1' },
  { value: 2, label: '2' },
  { value: 3, label: '3' },
  { value: 4, label: '4' },
  { value: 5, label: '5' },
  { value: 6, label: '6' },
  { value: 7, label: '7' },
  { value: 8, label: '8' },
  { value: 9, label: '9' },
];

export const SCHEDULING_MINUTES_OPTIONS = [
  { value: 0, label: '00' },
  { value: 5, label: '05' },
  { value: 10, label: '10' },
  { value: 15, label: '15' },
  { value: 20, label: '20' },
  { value: 25, label: '25' },
  { value: 30, label: '30' },
  { value: 35, label: '35' },
  { value: 40, label: '40' },
  { value: 45, label: '45' },
  { value: 50, label: '50' },
  { value: 55, label: '55' },
];

export const MAX_WORKING_HOURS_PERIOD_OPTIONS = [
  { value: 'per_day', label: 'Per day' },
  { value: 'per_week', label: 'Per week' },
];

export const POST_SHIFT_TO_STAFF_PART_OPTIONS = [
  { value: 'both_halves', label: 'Full shift' },
  { value: 'first_half', label: 'First half' },
  { value: 'second_half', label: 'Second half' },
];

export const genderOptions = [
  { value: 'male', label: 'Male' },
  { value: 'female', label: 'Female' },
];

export const stateOptions = [
  { value: 'AL', label: 'Alabama' },
  { value: 'AK', label: 'Alaska' },
  { value: 'AZ', label: 'Arizona' },
  { value: 'AR', label: 'Arkansas' },
  { value: 'CA', label: 'California' },
  { value: 'CO', label: 'Colorado' },
  { value: 'CT', label: 'Connecticut' },
  { value: 'DE', label: 'Delaware' },
  { value: 'FL', label: 'Florida' },
  { value: 'GA', label: 'Georgia' },
  { value: 'HI', label: 'Hawaii' },
  { value: 'ID', label: 'Idaho' },
  { value: 'IL', label: 'Illinois' },
  { value: 'IN', label: 'Indiana' },
  { value: 'IA', label: 'Iowa' },
  { value: 'KS', label: 'Kansas' },
  { value: 'KY', label: 'Kentucky' },
  { value: 'LA', label: 'Louisiana' },
  { value: 'ME', label: 'Maine' },
  { value: 'MD', label: 'Maryland' },
  { value: 'MA', label: 'Massachusetts' },
  { value: 'MI', label: 'Michigan' },
  { value: 'MN', label: 'Minnesota' },
  { value: 'MS', label: 'Mississippi' },
  { value: 'MO', label: 'Missouri' },
  { value: 'MT', label: 'Montana' },
  { value: 'NE', label: 'Nebraska' },
  { value: 'NV', label: 'Nevada' },
  { value: 'NH', label: 'New Hampshire' },
  { value: 'NJ', label: 'New Jersey' },
  { value: 'NM', label: 'New Mexico' },
  { value: 'NY', label: 'New York' },
  { value: 'NC', label: 'North Carolina' },
  { value: 'ND', label: 'North Dakota' },
  { value: 'OH', label: 'Ohio' },
  { value: 'OK', label: 'Oklahoma' },
  { value: 'OR', label: 'Oregon' },
  { value: 'PA', label: 'Pennsylvania' },
  { value: 'RI', label: 'Rhode Island' },
  { value: 'SC', label: 'South Carolina' },
  { value: 'SD', label: 'South Dakota' },
  { value: 'TN', label: 'Tennessee' },
  { value: 'TX', label: 'Texas' },
  { value: 'UT', label: 'Utah' },
  { value: 'VT', label: 'Vermont' },
  { value: 'VA', label: 'Virginia' },
  { value: 'WA', label: 'Washington' },
  { value: 'WV', label: 'West Virginia' },
  { value: 'WI', label: 'Wisconsin' },
  { value: 'WY', label: 'Wyoming' },
];

// Mirrors the ``max_length`` of ``Company.nurse_role_label`` / ``cna_role_label``
// in the backend: the inputs are capped at it so a label the API would reject
// cannot be typed at all.
export const ROLE_LABEL_MAX_LENGTH = 100;

// Mirrors the ``max_length`` of ``Unit.name`` in the backend.
export const UNIT_NAME_MAX_LENGTH = 100;

// Mirrors the ``max_length`` of ``UnitBed.bed`` in the backend. The room number
// and the bed are typed separately but stored concatenated in that one column,
// so the two inputs share this budget between them.
export const UNIT_BED_MAX_LENGTH = 20;

// Mirrors the ``max_length`` of ``Note.name`` (bedboard notes) in the backend.
export const NOTE_NAME_MAX_LENGTH = 255;
